import React from 'react';
import { useState, useEffect } from 'react';
import '../App.css';
import { Form, Container, Icon, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { storageUtils } from '../utils/localStorage';

export default function Final() {
  const [userEmail, setUserEmail] = useState('');
  const [userName, setUserName] = useState();
  const [userLoggedIn, setuserLoggedIn] = useState(false);
  const [completedItems, setcompletedItems] = useState([]);

  const [showMessage, setShowMessage] = useState();

  // const userEmail = 'dom@test.com';
  let chilliName = 'default';

  const logIn = () => {
    console.log('login', userEmail);
    if (userEmail !== '') {
      storageUtils.setUser(userEmail);

      console.log('---> users name: ', userName);

      storageUtils.setUserName(userName);
      setuserLoggedIn(true);
    }
  };

  const putItemsInLocalStorage = (item) => {
    console.log('!!!! >>>> putItemsInLocalStorage CALLED');

    // Use the utility function to add the item
    const updatedItems = storageUtils.addCompletedItem(item);

    // Update state
    setcompletedItems(updatedItems);

    console.log('Ive updated completed items');
    setTimeout(() => {
      console.log('completedItems update in state... ', completedItems);
      console.log(
        'Current year completed items:',
        storageUtils.getCompletedItems()
      );
    }, 3000);
  };

  const setChilliName = (value) => {
    chilliName = value;
    console.log('chilliname is now', chilliName);
  };

  // yellow
  const listOfChillis = [
    { id: '16', n: "Cristina Hall's Chilli", name: 'Sweater Weather Soup' },
    // Becky & Roy Coakley
    { id: '17', n: "Becky and Roy's Chilli", name: 'Spice It Up' },
    //Jamie Mendoza
    { id: '18', n: "Jamie Mendoza's Chilli", name: 'Brown Chicken Brown Cow' },
    //Jimmy Buczynski
    { id: '19', n: "Jimmy Buczynski's Chilli", name: 'Sassy Spice' }, // HIDDEN
    // Darren Ruback
    { id: '20', n: "Darren Ruback's Chilli", name: 'Papa Ds Chili' },
    // Katie Quebbeman
    { id: '21', n: "Katie Quebbeman's Chilli", name: 'Chili 21' }, // Katie doesnt have name
  ];

  const signUserOut = () => {
    console.log('signUserOut');
    setUserName(undefined);
    setUserEmail('');
    setcompletedItems([]); // Clear state

    // Clear user data but leave completed items (they're year-specific now)
    storageUtils.clearUser();

    setuserLoggedIn(false);
    setShowMessage('logout');
  };

  useEffect(() => {
    console.log('useEffect');
    const user = storageUtils.getUser();
    const userName = storageUtils.getUserName();

    if (user) {
      console.log('email is here in local storage');
      setUserEmail(user);

      if (userName) {
        setUserName(userName);
      }

      setuserLoggedIn(true);
    }

    // Get completed items for current year
    const completedItemsForYear = storageUtils.getCompletedItems();
    if (completedItemsForYear.length > 0) {
      console.log(
        `USE EFFECT: This user has voted for items in ${storageUtils.getCurrentYear()}. Setting state`
      );
      setcompletedItems(completedItemsForYear);

      setTimeout(() => {
        console.log(
          'USE EFFECT: completedItems update in state... ',
          completedItemsForYear
        );
      }, 3000);
    }

    console.log(
      `completedItems for ${storageUtils.getCurrentYear()} >>`,
      completedItemsForYear
    );

    const query = new URLSearchParams(window.location.search);
    console.log('url parameters', query);
    console.log(`window.location.search ${window.location.search}`);
    const completed = query.get('completed');
    console.log('completed url parameter: ', completed);

    if (completed) {
      console.log('there is an chili id in completed.', completed);
      putItemsInLocalStorage(completed);
    }

    const userEmailWhoCompletedGrading = query.get('ue');
    console.log(`userEmailWhoCompletedGrading ${userEmailWhoCompletedGrading}`);

    const signout = query.get('signout');
    if (signout === 'true') {
      console.log('there is a parameter in the URL to log out.');
      signUserOut();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header className="App-header">
      <div className="content">
        <div className="top-half"></div>

        <div style={{ height: '30px', padding: 0 }}>
          <img
            src="hot-pepper.png"
            alt="Hot pepper icon"
            style={{
              height: '90px',
              backgroundColor: 'white',
              position: 'relative',
              top: '-48px',
              padding: 20,
              borderRadius: 60,
            }}
          ></img>
        </div>

        <div className="text-container">
          <h4 className="custom-fonts" style={{ marginTop: 20 }}>
            Welcome to JJ's Chili Cookoff!
          </h4>
          {userLoggedIn && (
            <p style={{ fontSize: 18 }}>
              Time to eat and score each chilli below.
            </p>
          )}
        </div>

        {!userLoggedIn && (
          <div style={{ width: '100%', height: '40vh', padding: 3 }}>
            <p style={{ fontSize: 17 }}>
              Tasters, enter your email to get started.
            </p>

            <Container
              textAlign="left"
              style={{ padding: '5px 20px 200px 20px' }}
            >
              <Form>
                <Form.Field>
                  <label>Full Name</label>
                  <input
                    placeholder="Full Name"
                    onChange={(event) => setUserName(event.target.value)}
                  />
                </Form.Field>
                <Form.Field>
                  <label>Email</label>
                  <input
                    placeholder="BiebsWasHere@gmail.com"
                    onChange={(event) => setUserEmail(event.target.value)}
                  />
                </Form.Field>

                <Container textAlign="center">
                  <button className="email-btn" onClick={logIn}>
                    Start
                  </button>
                </Container>
                {/* <Button type='submit'>Submit</Button> */}
              </Form>
            </Container>
          </div>
        )}

        {userLoggedIn && (
          <div>
            <div className="chili-listing-container">
              <ul className="chilli-listings">
                {listOfChillis.map(function (item, id) {
                  return (
                    <li className="chilli-listing-item" key={item.id}>
                      <div className="ui grid" style={{ height: 70 }}>
                        {/* ICON */}
                        <div style={{ Top: 20 }} className="two wide column">
                          {completedItems.includes(item.id) ? (
                            <img
                              src="pot-icon-done.png"
                              alt="Completed pot icon"
                              style={{ height: 35, marginRight: 10 }}
                            ></img>
                          ) : (
                            <img
                              src="pot-icon.png"
                              alt="Pot icon"
                              style={{ height: 35, marginRight: 10 }}
                            ></img>
                          )}
                          <span
                            style={{
                              fontSize: 20,
                              position: 'relative',
                              left: 12,
                              top: -25,
                              color: 'white',
                            }}
                          >
                            {item.id}
                          </span>
                        </div>

                        <div
                          style={{ paddingTop: 25 }}
                          className="fourteen wide column"
                        >
                          <a
                            className="chili-link"
                            style={
                              item.name.length > 24 ? { fontSize: '16px' } : {}
                            }
                            onClick={() => {
                              setChilliName(item.name);
                            }}
                            href={
                              'https://form.typeform.com/to/NwRvOUFm#chilliname=' +
                              item.name +
                              '&chilliid=' +
                              item.id +
                              '&useremail=' +
                              userEmail +
                              '&username=' +
                              userName
                            }
                          >
                            {item.name}
                            {completedItems.includes(item.id) && (
                              <span style={{ paddingLeft: 8 }}>✅</span>
                            )}
                          </a>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
            <em style={{ fontSize: '9px', color: 'grey' }}>
              Final group <br></br>
            </em>
            {userEmail && (
              <em style={{ fontSize: '9px', color: 'grey' }}>
                Logged in as {userName} ({userEmail})
              </em>
            )}
            {/* <span>{completedItems}</span> */}
          </div>
        )}

        {showMessage === 'logout' && (
          <Message color="blue">
            Logged out. Please log back in with the same email you used last
            time
          </Message>
        )}

        <Container textAlign="right">
          <Link to="/settings">
            <Icon
              name="setting"
              size="small"
              style={{
                color: '#dbdbdb',
                position: 'relative',
                right: 10,
                bottom: 10,
              }}
            />
          </Link>
        </Container>
      </div>
    </header>
  );
}
